import "../styles/pages.scss";
import backgroud from "../assets/img/dataPage1_1.png";
import { useEffect, useState } from "react";
import { GetDataPages } from "../Location";

export function DataPage1() {
    const [state, setState] = useState("inActive");
    const [data, setData] = useState(null);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        let num = searchParams.get("num");
        setState("active");
        GetDataPages().then((d) => {
            setData(d.data[num])
            console.log(d.data[num]);
        });
    }, []);
    return (
        <div className="page">
            <img className="pageBackground" src={backgroud} />
            <div className="pageTop dataPage1">Гадаад улсын иргэдийг аялуулах бүтэн цогц үйлчилгээ</div>
            <div className={"left " + state}>
                <div className="mainText">{data&&data.title}</div>
                <div className="subText">{data&&data.day} </div>
                <table>
                    {
                        data&&data.datas.map((i) => {
                            return (
                                <tr className="tableInner">
                                    <td>{i.name}</td>
                                    <td>{i.time}</td>
                                </tr>
                            );
                        })
                    }
                </table>
            </div>
            <div className={"right " + state}>
                <div className="title">{data&&data.otherTitle}</div>
                <div className="text">
                    {data&&data.texts}
                </div>
            </div>
        </div>
    );
}
